import { render } from "./RatingTabLoader.vue?vue&type=template&id=3b911cc0&scoped=true"
import script from "./RatingTabLoader.vue?vue&type=script&lang=js"
export * from "./RatingTabLoader.vue?vue&type=script&lang=js"

import "./RatingTabLoader.vue?vue&type=style&index=0&id=3b911cc0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b911cc0"]])

export default __exports__